import type { VariantProps } from "class-variance-authority";
import { type PropsWithChildren, useMemo } from "react";

import { cn } from "../../utils";
import { AlertRootContextProvider } from "./context";
import { alertRootStyle } from "./styles";

export type AlertRootProps = PropsWithChildren<{ className?: string }> & VariantProps<typeof alertRootStyle>;

const Root = ({ className, type = "primary", children, orientation = "vertical" }: AlertRootProps) => {
  const contextValue = useMemo(() => ({ type, orientation }), [type, orientation]);

  return (
    <AlertRootContextProvider value={contextValue}>
      <div className={cn(alertRootStyle({ type, orientation }), className)}>{children}</div>
    </AlertRootContextProvider>
  );
};

export default Root;
